export class TaxRateComponentRequest {
  webApiName: string;
  webApiVersion: number;
  requestId: string;
  requestInfo: TaxRateComponentRequestInfo;
}

export class TaxRateComponentSaveRequest {
  webApiName: string;
  webApiVersion: number;
  requestId: string;
  requestInfo: TaxRateComponentRequestInfo[];
}

export class TaxRateComponentRequestInfo {
  taxRateComponentId: number;
  taxRateMasterId: number;
  taxCode: string;
  taxRate: number;
  taxAccountingCode: string;
  effectiveFrom: Date;
  effectiveTo: Date;
  isActive: boolean;
  CreatedBy: number;
  CreatedOn: Date;
  UpdatedBy: number;
  UpdatedOn: Date;
}
